import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TRUSTPILOT_RATING_COUNT, TRUSTPILOT_RATING_VALUE } from '@/config';
import trustPilotLogo from '@/images/logos/trustpilot.svg';

import Rating from './Rating';

function TrustPilotInfo({ small = false }) {
	const { i18n } = useTranslation();

	function formatValue(value) {
		return new Intl.NumberFormat(i18n.language).format(value);
	}

	const countContent = (
		<>
			<Typography
				component="span"
				variant="body1"
				fontWeight={600}
				sx={{ marginInlineStart: small ? 0 : '12px' }}
			>
				{formatValue(TRUSTPILOT_RATING_COUNT)}
			</Typography>

			<Typography
				component="span"
				variant="body1"
				color="text.secondary"
				sx={{ marginInlineStart: '8px' }}
			>
				Reviews on
			</Typography>

			<Box
				component="img"
				src={trustPilotLogo}
				alt="Trustpilot"
				width={98}
				height={28}
				sx={{ marginInlineStart: '8px' }}
			/>
		</>
	);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexWrap: small ? 'wrap' : 'nowrap',
				gap: small ? '10px' : 0
			}}
		>
			<Typography variant="body2" fontWeight={600}>
				Excellent
			</Typography>

			<Rating
				value={TRUSTPILOT_RATING_VALUE}
				sx={{ marginInlineStart: '16px' }}
			/>

			{small ? (
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					{countContent}
				</Box>
			) : (
				countContent
			)}
		</Box>
	);
}

export default TrustPilotInfo;
